module.exports = __webpack_public_path__ + "static/media/EE3.4b6ed351.PNG";